import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import MainLayout from './MainLayout';
import SongMode from './SongMode';
import ConcertCalendar from './ConcertCalendar';
import LoginPage from './LoginPage';
import RegisterPage from './RegisterPage';
import UserContext from './UserContext';
import { useState } from 'react';
import ArtistProfile from './ArtistProfile';
import { Link } from 'react-router-dom';

const isMobileDevice = () => {
  return /android|iphone|ipad|ipod|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase());
};

function App() {
  const [user, setUser] = useState(null);

  return (
   <UserContext.Provider value={{ user, setUser }}>
    <Router>
      <Routes>
	  <Route
  path="/"
  element={
    isMobileDevice() ? (
      <MainLayout mode="show-mode">
        <ConcertCalendar />
      </MainLayout>
    ) : (
      <MainLayout mode="song-mode">
        <SongMode />
      </MainLayout>
    )
  }
/>

<Route
  path="/shows"
  element={
    <MainLayout mode="show-mode">
      <ConcertCalendar />
    </MainLayout>
  }
/>

<Route
  path="/songs"
  element={
    <MainLayout mode="song-mode">
      <SongMode />
    </MainLayout>
  }
/>
	<Route path="/login" element={<LoginPage />} />
	<Route path="/register" element={<RegisterPage />} /> 
        <Route path="/artist/:username" element={<ArtistProfile />} />
      </Routes>
    </Router>
   </UserContext.Provider>
  );
}

export default App;
